




import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class PasswordResetRedirect extends Vue {
  $appOptions: any;
  mounted() {
    try {
      location.href = `${this.$appOptions.authority}/interaction/${this.$route.params.code}/resetpassword`;
    } catch (error) {
      console.error("catchedError", error);
    }
  }
}
